import React from 'react';
import { Card, CardContent, Box } from '@mui/material';

const AuthCard = ({ children, sx }) => {
  return (
    <Card
      elevation={0}
      sx={(theme) => ({
        maxWidth: 520,
        width: '100%',
        borderRadius: 4,
        backgroundColor:
          theme.palette.mode === 'dark'
            ? 'rgba(12, 23, 42, 0.82)'
            : 'rgba(255, 255, 255, 0.94)',
        backdropFilter: 'blur(20px)',
        border: `1px solid ${
          theme.palette.mode === 'dark'
            ? 'rgba(148, 163, 184, 0.22)'
            : 'rgba(148, 163, 184, 0.28)'
        }`,
        boxShadow:
          theme.palette.mode === 'dark'
            ? '0 32px 64px rgba(15, 23, 42, 0.55)'
            : '0 28px 56px rgba(15, 23, 42, 0.18)',
        transition: 'box-shadow 220ms ease, transform 220ms ease',
        '&:hover': {
          transform: 'translateY(-2px)',
          boxShadow:
            theme.palette.mode === 'dark'
              ? '0 36px 72px rgba(15, 23, 42, 0.62)'
              : '0 32px 64px rgba(15, 23, 42, 0.22)',
        },
        ...((typeof sx === 'function' ? sx(theme) : sx) || {}),
      })}
    >
      <CardContent sx={{ p: { xs: 3, sm: 4 } }}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: { xs: 1.75, sm: 2.5 },
          }}
        >
          {children}
        </Box>
      </CardContent>
    </Card>
  );
};

export default AuthCard;
